<div class="chart">
  <div>
    <app-base-inline-form [fields]="fields" [model]="model"></app-base-inline-form>
  </div>
  <app-bar-chart
    i18n-yAxisName
    i18n-yAxisNameRight
    yAxisName="Total"
    yAxisNameRight="Count"
    [header]="header()"
    [xKey]="xKey()"
    [xFormat]="BarChartAxisType.date"
    [xAxisName]="xAxisName"
    [yKey]="yKey()"
    [yName]="yName()"
    [yFormat]="yFormat()"
    [xRotation]="xRotation()"
    [yKeyRight]="yKeyRight()"
    [yNameRight]="yNameRight()"
    [yFormatRight]="yFormatRight()"
    [showLegend]="true"
    [data$]="data$"
    [subHeaderFunc]="getSubHeader.bind(this)"
    [dateFormatFunc]="dateFormat.bind(this)"
    (clicked)="clicked($event)"
  ></app-bar-chart>
</div>
